import { ExecutionSettingsDTO } from '@/types';
import { AwsInstanceSize } from '@/types/admin/AwsInstanceSize';
import { api } from '@prometheus/utils';

export const getAwsInstanceSizesList = (): Promise<Array<AwsInstanceSize>> =>
  api.get('/execution/settings/instance-sizes');

export const getExecutionSettings = (): Promise<ExecutionSettingsDTO> =>
  api.get('/execution/settings');

export const updateExecutionSettings = (
  data: ExecutionSettingsDTO
): Promise<ExecutionSettingsDTO> => api.put('/execution/settings', data);

export const getDescriptors: any = () => {
  return api.get('/datanode/descriptors/list');
};

export const getDescriptorId = (id: string) => {
  return api.get(`/datanode/descriptors/${id}`);
};
